import Tria from '@/pages/Tria/Index'
import TriaPorEquipeAcs from '@/pages/Tria/PorEquipeAcs'
import TriaPorProfissional from '@/pages/Tria/PorAcs'

export default [
  {
    path: '/tria',
    component: () => import('@/pages/Tria/Template.vue'),
    children: [
      {
        path: '/tria',
        component: Tria,
      },
      {
        path: '/tria/equipe/acs',
        component: TriaPorEquipeAcs,
      },
      {
        path: '/tria/profissional',
        component: TriaPorProfissional,
      }
    ],
  },
]